module.exports = __webpack_public_path__ + "img/ID_VK_Icon.abe4ae91.svg";